import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199
import * as copyToClipboard from 'copy-to-clipboard';

interface Props {
    textToCopy: string;
    notificationTimeout?: number;
    notificationText?: string | JSX.Element;
}

interface State {
    isClicked: boolean;
}

const twoSeconds = 2000;

class CopyToClipboard extends React.Component<Props, State> {
    notificationTimeout: number;
    timeoutRef: any;

    constructor(props) {
        super(props);
        this.doCopy = this.doCopy.bind(this);
        this.state = { isClicked: false };
        if (props.notificationTimeout) {
            this.notificationTimeout = props.notificationTimeout;
        } else {
            this.notificationTimeout = twoSeconds;
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutRef);
    }

    doCopy() {
        copyToClipboard(this.props.textToCopy);
        this.setState(() => ({ isClicked: true }));
    }

    render() {
        return (
            <div className="sid-to-clipboard">
                <div
                    onClick={this.doCopy}
                    onKeyPress={this.doCopy}
                    role="button"
                    tabIndex={0}
                    className={`sid-h-link-like sid-to-clipboard__clickable-text sid-link ${this.state.isClicked ? 'sid-to-clipboard__clickable-text-clicked' : ''}`}
                >
                    { this.state.isClicked ? 'Coupon Code Copied!' : this.props.children}
                </div>
            </div>
        );
    }
}

export { CopyToClipboard };
